import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore(
  'dashboard-contacts-income',
  storeModule.createStoreModule('dashboard-contacts-income', {
    fetchListURL: 'dashboard/contacts-income'
  })
)
